/**
 * Creates an object that can be used by the fetch API to make a request.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch
 */
export default class RequestBuilder {
    static jsonRequest() {
        return new RequestBuilder()
            .header('accept', 'application/json')
            .header('content-type', 'application/json');
    }

    /**
     * Creates a new instance of RequestBuilder.
     * @param {RequestBuilder} [requestObject] the RequestBuilder to copy into this instance. If
     * this value is not truthy, create an instance of RequestBuilder with the default value.
     */
    constructor(requestObject) {
        if (requestObject instanceof RequestBuilder) {
            this.requestEndpoint = requestObject.requestEndpoint;
            this.request = requestObject.request;
        } else {
            this.requestEndpoint = '';
            this.request = {
                headers: new Headers(),
            };
        }

        this.cache('no-cache')
            .mode('cors')
            .method('GET');
    }

    /**
     * Sets the method to use for this request. This is sometimes called the http verb, its
     * usually "GET" or "POST"
     * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html
     * @param {string} value One of the valid HTTP verbs as specified in RFC2616 Section 9
     * @default POST
     * @returns {RequestBuilder} This RequestBuilder instance.
     */
    method(value) {
        this.request.method = value;

        return this;
    }

    /**
     * Appends a header to the request.
     * @param {string} name The name of the header to append.
     * @param {string} value The value of the header to append.
     * @returns {RequestBuilder} This RequestBuilder instance.
     */
    header(name, value) {
        this.request.headers.append(name, value);

        return this;
    }

    /**
     * Sets the request's body content.Some methods like GET do not support body content.
     * @param {Blob|BufferSource|FormData|URLSearchParams|string} value The content body value.
     * @returns {RequestBuilder} This RequestBuilder instance.
     */
    body(value) {
        this.request.body = value;

        return this;
    }

    /**
     * Sets the request's body content using JSON.stringify. Some methods like GET do not support
     * body content.
     * @param {*} value The content body value.
     * @returns {RequestBuilder} This RequestBuilder instance.
     */
    bodyJson(value) {
        this.request.body = JSON.stringify(value);

        return this;
    }

    /**
     * The request's mode
     * @param {string} value one of "same-origin", "no-cors", "cors", or "navigate"
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Request/mode
     * @returns {RequestBuilder} This RequestBuilder instance.
     */
    mode(value) {
        this.request.mode = value;

        return this;
    }

    credentials(value) {
        this.request.credentials = value;

        return this;
    }

    cache(value) {
        this.request.cache = value;

        return this;
    }

    redirect(value) {
        this.request.redirect = value;

        return this;
    }

    referrer(value) {
        this.request.referrer = value;

        return this;
    }

    referrerPolicy(value) {
        this.request.referrerPolicy = value;

        return this;
    }

    integrity(value) {
        this.request.integrity = value;

        return this;
    }

    endpoint(value) {
        this.requestEndpoint = value;

        return this;
    }


    fetch() {
        return fetch(this.requestEndpoint, this.request);
    }


}


// WEBPACK FOOTER //
// ./source/framework/core/RequestBuilder.js